module.exports = __webpack_public_path__ + "img/osu.ef415828.svg";